import React from "react";
import IconAeps from "../../assets/images/IconAeps";

import Recharge from "../../assets/images/prepaid_recharge.svg";
import Bills from "../../assets/images/Bills.jpg";
import payout from "../../assets/images/Payout.jpg";
import Aadhaarpay from "../../assets/images/Aadhaarpay.svg";
import utiregistration from "../../assets/images/UTI_Registration.jpg";
import dmr from "../../assets/images/DMR.jpg";
import dth from "../../assets/images/p2m_DTH-removebg-preview.png";
import { useState } from "react";
import { useEffect } from "react";
import { isEmpty } from "../../utils/common";
import { useNavigate } from "react-router-dom";

import IRCTC from "../../assets/images/IRCTC.svg";
import wallet from "../../assets/images/wallet.png";
import IconFlight from '../../assets/images/IconFlight';
import IconHotel from '../../assets/images/IconHotel';
import IconBus from '../../assets/images/IconBus';
import { useSelector } from "react-redux";

export default function PaymentCards(serviceData) {
  const [bppsRechargeCount, setBbpsRechargeCount] = useState(0);
  const [sumBbpsRecharge, setSumBbpsRecharge] = useState(0);
  const navigate = useNavigate();
   const { user } = useSelector((state) => state.user);
 
const service = serviceData?.serviceData;
let bbpsDataSum = service?.bbpsCollection;
    

  const sumOfBbpsRecharge = () => {
    if (!isEmpty(bbpsDataSum)) {
      let bbpsdata = Object.values(bbpsDataSum);
      let sum = 0,
        count = 0;
      bbpsdata.map((val) => {
       
        sum +=  val.amount;
        count += val.count;

      });
      
      let finalSum = sum ;
      let finalCount = count;
      setSumBbpsRecharge(finalSum);
      setBbpsRechargeCount(finalCount);     
      return finalSum,finalCount;     
    } 
    else {
      setBbpsRechargeCount(0)
      setSumBbpsRecharge(0)
    } 
   
  };
 
  useEffect(() => {
    sumOfBbpsRecharge();
    // sumOfPrepaidRecharge();
  },[serviceData]);
  console.log("service",service)

  const cardList = [
    {
      icon:dmr,
      title:"Send Money",
      amount:service?.moneyTransfer?.send_money?.amount || 0,
      count:service?.moneyTransfer?.send_money?.count || 0,
      url:"/transactions",
      type:"SEND_MONEY",
      Componant:"",
      Permissions:["ROLE_DISTRIBUTOR","ROLE_SUBADMIN","ROLE_ADMIN","ROLE_MASTER_DISTRIBUTOR"]
    },
    {
      icon:dmr,
      title:"UPI Pay",
      amount:service?.moneyTransfer?.upi_pay?.amount || 0,
      count:service?.moneyTransfer?.upi_pay?.count || 0,
      url:"/transactions",
      type:"UPI_PAY",
      Componant:"",
      Permissions:["ROLE_DISTRIBUTOR","ROLE_SUBADMIN","ROLE_ADMIN","ROLE_MASTER_DISTRIBUTOR"]
    },
    {
      icon:"",
      title:"AEPS",
      amount:service?.aepsTransaction?.aeps?.amount || 0,
      count:service?.aepsTransaction?.aeps?.count || 0,
      url:"/transactions",
      type:"AEPS",
      Componant:IconAeps,
      Permissions:["ROLE_DISTRIBUTOR","ROLE_SUBADMIN","ROLE_ADMIN","ROLE_MASTER_DISTRIBUTOR"]
    },
    {
      icon:Aadhaarpay,
      title:"Aadhar Pay",
      amount:service?.aepsTransaction?.aadhaar_pay?.amount || 0,
      count:service?.aepsTransaction?.aadhaar_pay?.count || 0,
      url:"/transactions",
      type:"AADHAAR_PAY",
      Componant:"",
      Permissions:["ROLE_DISTRIBUTOR","ROLE_SUBADMIN","ROLE_ADMIN","ROLE_MASTER_DISTRIBUTOR"]
    },
    {
      icon:Recharge,
      title:"Mobile Recharge",
      amount:service?.rechargeCollection?.mobile?.amount || 0,
      count:service?.rechargeCollection?.mobile?.count || 0,
      url:"/transactions",
      type:"PREPAID_RECHARGE",
      Componant:"",
      Permissions:["ROLE_DISTRIBUTOR","ROLE_SUBADMIN","ROLE_ADMIN","ROLE_MASTER_DISTRIBUTOR"]
    },
    {
      icon:dth,
      title:"DTH Recharge",
      amount:service?.rechargeCollection?.dth?.amount || 0,
      count:service?.rechargeCollection?.dth?.count || 0,
      url:"/transactions",
      type:"PREPAID_RECHARGE",
      Componant:"",
      Permissions:["ROLE_DISTRIBUTOR","ROLE_SUBADMIN","ROLE_ADMIN","ROLE_MASTER_DISTRIBUTOR"]
    },
    {
      icon:Bills,
      title:"BBPS",
      amount:sumBbpsRecharge || 0,
      count:bppsRechargeCount || 0,
      url:"/transactions",
      type:"BBPS",
      Componant:"",
      Permissions:["ROLE_DISTRIBUTOR","ROLE_SUBADMIN","ROLE_ADMIN","ROLE_MASTER_DISTRIBUTOR"]
    },
    {
      icon:payout,
      title:"Payout",
      amount:service?.moneyTransfer?.pay_out?.amount || 0,
      count:service?.moneyTransfer?.pay_out?.count || 0,
      url:"/transactions",
      type:"PAY_OUT",
      Componant:"",
      Permissions:["ROLE_DISTRIBUTOR","ROLE_SUBADMIN","ROLE_ADMIN","ROLE_MASTER_DISTRIBUTOR"]
    },
    {
      icon:utiregistration,
      title:"Settlement Balance",
      amount:service?.moneyTransfer?.settlement?.amount || 0,
      count:service?.moneyTransfer?.settlement?.count || 0,
      url:"/transactions",
      type:"SETTLEMENT",
      Componant:"",
      Permissions:["ROLE_DISTRIBUTOR","ROLE_SUBADMIN","ROLE_ADMIN","ROLE_MASTER_DISTRIBUTOR"]
    },
    {
      icon:utiregistration,
      title:"Add Money",
      amount:service?.addMoney?.amount || 0,
      count:service?.addMoney?.count || 0,
      url:"/transactions",
      type:"PAYMENT_GATEWAY",
      Componant:"",
      Permissions:["ROLE_DISTRIBUTOR","ROLE_SUBADMIN","ROLE_ADMIN","ROLE_MASTER_DISTRIBUTOR"]
    },
    {
      icon:Bills,
      title:"POS",
      amount:service?.pos?.amount || 0,
      count:service?.pos?.count || 0,
      url:"/transactions",
      type:"POS",
      Componant:"",
      Permissions:["ROLE_DISTRIBUTOR","ROLE_SUBADMIN","ROLE_ADMIN","ROLE_MASTER_DISTRIBUTOR"]
    },
    {
      icon:IRCTC,
      title:"IRCTC",
      amount:service?.irctc?.amount || 0,
      count:service?.irctc?.count || 0,
      url:"/transactions",
      type:"IRCTC",
      Componant:"",
      Permissions:["ROLE_DISTRIBUTOR","ROLE_SUBADMIN","ROLE_ADMIN","ROLE_MASTER_DISTRIBUTOR"]
    },
    {
      icon:Bills,
      title:"CDM",
      amount:service?.cdmCollection?.amount || 0,
      count:service?.cdmCollection?.count || 0,
      url:"/transactions",
      type:"CDM",
      Componant:"",
      Permissions:["ROLE_DISTRIBUTOR","ROLE_SUBADMIN","ROLE_ADMIN","ROLE_MASTER_DISTRIBUTOR"]
    },
    {
      icon:wallet,
      title:"Virtual Account",
      amount:service?.virtualAccountSummary?.amount || 0,
      count:service?.virtualAccountSummary?.count || 0,
      url:"/transactions",
      type:"VIRTUAL_ACCOUNT",
      Componant:"",
      Permissions:["ROLE_DISTRIBUTOR","ROLE_SUBADMIN","ROLE_ADMIN","ROLE_MASTER_DISTRIBUTOR"]
    },


    {
      icon:"",
      title:"Flight",
      amount:service?.bookingTransaction?.flight?.amount || 0,
      count:service?.bookingTransaction?.flight?.count || 0,
      url:"/transactions",
      type:"FLIGHT",
      Componant:IconFlight,
      Permissions:["ROLE_SUBADMIN","ROLE_ADMIN"]
    },
    {
      icon:"",
      title:"Hotel",
      amount:service?.bookingTransaction?.hotel?.amount || 0,
      count:service?.bookingTransaction?.hotel?.count || 0,
      url:"/transactions",
      type:"HOTEL",
      Componant:IconHotel,
      Permissions:["ROLE_SUBADMIN","ROLE_ADMIN"]
    },
    {
      icon:"",
      title:"Bus",
      amount:service?.bookingTransaction?.bus?.amount || 0,
      count:service?.bookingTransaction?.bus?.count || 0,
      url:"/transactions",
      type:"BUS",
      Componant:IconBus,
      Permissions:["ROLE_SUBADMIN","ROLE_ADMIN"]
    },
  ]


  return (
    <div className="payment-cards">
      {
        cardList.map((card,index) =>{
          if(!card.Permissions.includes(user?.userType)) return "";
               return <Card icon={card?.icon} title={card?.title} amount={card?.amount} count={card?.count} url={card?.url} type={card?.type} Componant={card?.Componant}  />;
        })
      }

    </div>
  );
}


const Card = ({icon="",title="",amount=0,count=0, url="", type="", Componant=""}) =>{

  const navigate = useNavigate();

  return(
    <>
    <div className="payment-card"
    onClick={(e) => navigate(url,{state:{type:type}})}>
      <div className="flex justify-between">
      <div className="payment-logo" style={{maxWidth:"40px"}}>
       {!isEmpty(icon)&& <img src={icon} style={{width:"100%"}}></img>}
       {!isEmpty(Componant)&& <Componant />}
        </div>
      <div className="payment-title" style={{ fontWeight: "600" }}>
        {title}
      </div>
      </div>
    
      <div className="bottom-info">
        <div>
          <div className="payment-count fs-12">
            <span style={{ color: "black" }}>Amount : </span>₹{" "}
            {isEmpty(amount)
              ? "0"
              : (Math.round(amount * 100) / 100).toFixed(2)}
          </div>
          <div className="payment-count fs-12">
            <span style={{ color: "black" }}>Count : </span>
            {isEmpty(
             count
            )
              ? "0"
              : count}
          </div>
        </div>
        
      </div>
    </div>
    </>
  )

}